import React from "react";
import { withRouter } from "react-router-dom";
import { Icon } from "react-materialize";
import { Link } from "react-router-dom";
import { isBackOffice } from "../../../shared/service/AccountService";
import { connect } from "react-redux";
import Notifications from "../../../pages/notification/Notifications";
import "./Toolbar.css";

class Toolbar extends React.Component {
  state = {
    isHidden: true,
    showAlerts: false,
    showSettings: false
  };

  toggleShowAlerts = () => {
    this.setState(state => ({ showAlerts: !this.state.showAlerts }));
  };
  toggleShowSettings = () => {
    this.setState(state => ({ showSettings: !this.state.showSettings }));
  };

  toggleTheme = () => {
    const body = document.getElementsByTagName("body");
    if (body[0].classList.contains("dark-theme")) {
      body[0].classList.remove("dark-theme");
      localStorage.setItem("theme", "light-theme");
    } else {
      body[0].classList.add("dark-theme");
      localStorage.setItem("theme", "dark-theme");
    }
  };

  handleClickOutside = () => {
    this.setState(state => ({ showAlerts: false }));
    this.setState(state => ({ showSettings: false }));
  };

  toggleHidden() {
    this.setState({
      isHidden: !this.state.isHidden
    });
  }

  handleClick = () => {
    localStorage.clear();
    this.props.history.push(`/login`);
  };

  openProfile = () => {
    this.props.history.push(`/user/profile`);
  };

  canShowNewOrderService = () => {
    return this.props.location.pathname !== "/orderservice";
  };

  componentWillMount() {
    document.addEventListener("mousedown", this.clickHandle, false);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.clickHandle, false);
  }
  clickHandle = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClickOutside();
  };

  render() {
    return (
      <React.Fragment>
        <div className="container-toolbar">
          <div>
            <Notifications {...this.props} />
          </div>
          <div className="add-os">
            {this.canShowNewOrderService() ? (
              <Link to="/orderservice">
                <span>Nova OS</span>
              </Link>
            ) : null}
          </div>
          {/* <div className="toolbar-right">
            <div className="photo-profile">
              <img src={PhotoProfile} alt="Usuário" />
            </div>
          </div> */}
          <div className="container-toolbar">
            {/* <div className="icon-action">
              <div ref={node => this.node = node} className={this.state.showAlerts ? 'box box-alerts open' : 'box box-alerts'} >
                <ul>
                  <li className="item-notification">
                    <span>Ordem de Serviço</span>
                    <h6>OS 523453534 foi alterada para ‘Concluída’</h6>

                  </li>
                  <li className="item-notification">
                    <span>Mensagem Recebida</span>
                    <h6>Contratante enviou uma mensagem</h6>
                  </li>

                </ul>

              </div>
            </div> */}
            <div className="icon-action">
              <span onClick={this.toggleShowSettings}>
                <Icon>settings</Icon>
              </span>

              <div
                ref={node => (this.node = node)}
                className={
                  this.state.showSettings
                    ? "box box-settings open"
                    : "box box-settings"
                }
              >
                <ul>
                  <li onClick={this.toggleTheme}>Mudar Tema</li>
                  {!isBackOffice() && (
                    <li onClick={this.openProfile}>Perfil</li>
                  )}
                  <li onClick={this.handleClick}>Sair</li>
                </ul>
              </div>
            </div>
          </div>
          {/*<div onClick={this.handleClick}>
            <Icon className="exit-icon">exit_to_app</Icon>
            </div>*/}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    orderservice: state.serviceOrder,
    company: state.company
  };
};

Toolbar = connect(mapStateToProps, undefined)(Toolbar);

export default withRouter(Toolbar);



// WEBPACK FOOTER //
// ./src/shared/component/toolbar/Toolbar.js